import {Component} from '@angular/core';
import {SidebarNavigation} from "./sidebar-navigation/sidebar-navigation";
import {SidebarNavigationLogout} from './sidebar-navigation-logout/sidebar-navigation-logout';
import {CompanySelector} from './company-selector/company-selector';
import {UserStateService} from '@services/frontend/user-state.service';
import {Role} from '@models/user.interface';

@Component({
  selector: 'app-sidebar',
  imports: [CompanySelector, SidebarNavigation, SidebarNavigationLogout],
  templateUrl: './sidebar.html',
})
export class Sidebar {
  constructor(private readonly userStateService: UserStateService) {}

  showCompanySelector(): boolean {
    return this.userStateService.getUser()()?.role !== Role.ACCOUNTANT;
  }
}
